import { Spinner, TxDataCard } from "@src/components";
import { useHistory } from "@src/context";
import { useWallet } from "@src/context/WalletProvider";
import { useMemo } from "react";
import { Virtuoso } from "react-virtuoso";

export const HistoryView = () => {
  const { history, historyLoadedOnce, solanaHistory, solanaHistoryLoadedOnce } =
    useHistory();
  const {
    solana: { address: solanaAddress },
  } = useWallet();

  const unifiedHistory = useMemo(() => {
    const combinedHistory = [
      ...history,
      ...(solanaAddress ? solanaHistory : []),
    ];
    return combinedHistory.sort((a, b) => {
      return b.timestamp - a.timestamp;
    });
  }, [history, solanaHistory, solanaAddress]);

  const view = useMemo(() => {
    if (!unifiedHistory || unifiedHistory.length === 0) {
      const isHistoryLoaded =
        historyLoadedOnce && (solanaAddress ? solanaHistoryLoadedOnce : true);

      return isHistoryLoaded ? (
        <div className="text-center py-4 text-[#9e9e9e]">
          Your history is empty
        </div>
      ) : (
        <div className="flex justify-center w-full py-4 fill-t_text_primary">
          <Spinner className="w-8 h-8" />
        </div>
      );
    }

    return (
      <Virtuoso
        data={unifiedHistory}
        style={{ height: "532px" }}
        itemContent={(_, transaction) => {
          return <TxDataCard transaction={transaction} />;
        }}
      />
    );
  }, [
    historyLoadedOnce,
    solanaHistoryLoadedOnce,
    unifiedHistory,
    solanaAddress,
  ]);

  return <div className="flex-1 overflow-hidden">{view}</div>;
};
